<template>
    <referral-member-list
        :title="$t('text.MyTeam')"
        :description="$t('text.teamDesc')"
        api-url="/api/m/referral/team"
    />
</template>

<script>
import ReferralMemberList from '@/components/computer/ReferralMemberList.vue'

export default {
    components: {
        ReferralMemberList,
    },
}
</script>
